<template>
    <div class="Man-CF7MenuPrincipal">
        <PageTitle icon="fa fa-shopping" main="CF7"
            sub="STORE " />
        <div class="Man-CF7MenuPrincipal">
            <b-card no-body>
                <b-tabs>                                                            
                    <b-tab title="Vendas" active><Vendas /></b-tab>      
                    <b-tab title="Gestão de vendas" ><Lancamentos /></b-tab>      
                    <b-tab title="Financeiro" ><Financeiro /></b-tab>  
                    <b-tab title="Indicadores" ><CF7Indicadores /></b-tab>                                                                                                                                                      
                    <b-tab title="Fornecedores" ><Fornecedores /></b-tab>        
                    <b-tab title="Produtos" ><Produtos /></b-tab>        
                    <b-tab title="Entrada de mercadorias" ><EntradaMercadorias /></b-tab>        
                    <b-tab title="Vendas por funcionários" ><VendasFuncionario /></b-tab>        
                    
                </b-tabs>
            </b-card>
        </div>
    </div>
</template>

<script>
import PageTitle from '../template/PageTitle'
import Vendas from '../sambaiba/CF7Vendas'
import Lancamentos from '../sambaiba/CF7Lancamentos'
import Financeiro from '../sambaiba/CF7Financeiro'
import CF7Indicadores from '../sambaiba/CF7Painel'
import EntradaMercadorias from '../sambaiba/CF7EntradaMercadoria'
import Fornecedores from '../sambaiba/ClienteFornecedor'
import Produtos from '../sambaiba/CF7Produtos'
import VendasFuncionario from '../sambaiba/CF7VendasFuncionarios'

export default {
    name: 'CF7MenuPrincipal',    
    components: {PageTitle,Vendas,Lancamentos,Financeiro,CF7Indicadores,Fornecedores,EntradaMercadorias,Produtos,VendasFuncionario}
    
}
</script>

<style>

</style>







